import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Axios instance that ALWAYS sends cookies (httpOnly session_token)
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// ---- Public ----
export const fetchPublicArticles = (limit = 6) =>
  api.get(`/articles?limit=${limit}`).then((r) => r.data);

// ---- Auth ----
export const exchangeSession = (session_id) =>
  api.post(`/auth/session`, { session_id }).then((r) => r.data);

export const fetchMe = () => api.get(`/auth/me`).then((r) => r.data);

export const logout = () => api.post(`/auth/logout`).then((r) => r.data);

// ---- Admin ----
export const adminListArticles = () =>
  api.get(`/admin/articles`).then((r) => r.data);

export const adminGetArticle = (id) =>
  api.get(`/admin/articles/${id}`).then((r) => r.data);

export const adminCreateArticle = (payload) =>
  api.post(`/admin/articles`, payload).then((r) => r.data);

export const adminUpdateArticle = (id, payload) =>
  api.put(`/admin/articles/${id}`, payload).then((r) => r.data);

export const adminDeleteArticle = (id) =>
  api.delete(`/admin/articles/${id}`).then((r) => r.data);
